/**
 * shutdown-response.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

export class ShutdownResponse extends IncomingMessage
{
    public tag : MessageTag = MessageTag.RSP_SHUTDOWN;

    public shutdownPending : boolean;
    public secondsTillShutdown : number;

    public static StandardMessage : string =
        " minutes until the application is shut down (approximate). Please save your work.";
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/shutdown-response.ts